import { useForm } from 'antd/lib/form/Form';
import Form from 'antd/lib/form';
import DatePicker from 'antd/lib/date-picker';
import dayjs from 'dayjs';
import Button from 'antd/lib/button';
import { CheckOutlined } from '@ant-design/icons';
import * as React from 'react';

const DatePickerTimeRange = (props) => {
    const initialTimeRangeInDays = props.initialTimeRangeInDays || 90;
    const defaultDates = [dayjs().subtract(initialTimeRangeInDays, 'days'), dayjs()];
    const [form] = useForm();
    const [isButtonDisabled, setIsButtonDisabled] = React.useState(true);
    const [userUpdatedCalendarDates, setUserUpdatedCalendarDates] = React.useState(false);

    // Disable dates outside a specific range (if needed)
    const disabledDate = (current) => {
        // Example logic: Disable dates outside of a specific range
        const start = current.start;
        const end = current.end;

        if (start && end) {
            return start.diff(end) < 14 || start.diff(end) > 90;
        }

        return false;
    };

    const watchedRange = Form.useWatch('metricsDateRange', form);

    React.useEffect(() => {
        const hasUserTouched = userUpdatedCalendarDates;
        const isLoading = props.isLoading;

        const isValidRange = () => {
            if (!watchedRange || watchedRange.length !== 2) return false;
            const [start, end] = watchedRange;
            if (!dayjs.isDayjs(start) || !dayjs.isDayjs(end)) return false;

            if (props.allowAnyTimeRange) return true;

            const dayDiff = end.diff(start, 'day');
            return dayDiff >= 14 && dayDiff <= 90;
        };

        if (!hasUserTouched || !isValidRange() || isLoading) {
            setIsButtonDisabled(true);
        } else {
            setIsButtonDisabled(false);
        }
    }, [watchedRange, userUpdatedCalendarDates, props.isLoading]);

    const onRangePickerChanges = (changedFields) => {
        const changedField = changedFields.find((field) => field.name.includes('metricsDateRange'));
        if (!changedField) return;

        const changedValue = changedField.value || [];
        const [start, end] = changedValue;

        const isCleared = !start && !end;
        const isDefault = dayjs(defaultDates[0]).isSame(start, 'day') && dayjs(defaultDates[1]).isSame(end, 'day');

        if (isCleared) {
            form.setFieldsValue({ metricsDateRange: defaultDates });
            props.onFinish({ metricsDateRange: defaultDates });
            setUserUpdatedCalendarDates(false); // this disables the button
        } else if (!isDefault) {
            // it's truly a user change
            setUserUpdatedCalendarDates(true);
        } else {
            // they changed to defaultDates manually
            setUserUpdatedCalendarDates(false);
        }
    };

    return (
        <Form
            form={form}
            onFinish={(dates) => {
                props.onFinish(dates);
                setUserUpdatedCalendarDates(false);
            }}
            layout="vertical"
            initialValues={{ metricsDateRange: defaultDates }}
            style={{
                display: 'inline-flex',
                justifyContent: 'end',
                alignItems: 'center',
                height: 'fit-content',
            }}
            onFieldsChange={onRangePickerChanges}
        >
            <div style={{ maxHeight: '40px', display: 'flex', overflow: 'visible' }}>
                <Form.Item
                    name="metricsDateRange"
                    style={{
                        justifyContent: 'end',
                        font: 'inherit',
                    }}
                    rules={[
                        {
                            validator: (_, value) => {
                                if (!value || value.length !== 2) {
                                    return Promise.reject(new Error('Please select a valid date range'));
                                }

                                const [start, end] = value;
                                const timeDayRange = end.diff(start, 'day');

                                if (!dayjs.isDayjs(start) || !dayjs.isDayjs(end)) {
                                    return Promise.reject(new Error('Invalid date format'));
                                }

                                if (!props.allowAnyTimeRange) {
                                    if (timeDayRange > 90) {
                                        return Promise.reject(new Error('Cannot exceed 90 days'));
                                    } else if (timeDayRange < 14 && timeDayRange !== 0) {
                                        return Promise.reject(new Error('Cannot be less than 14 days'));
                                    }
                                }

                                return Promise.resolve();
                            },
                        },
                    ]}
                >
                    <DatePicker.RangePicker disabledDate={disabledDate} />
                </Form.Item>
                <Button
                    disabled={isButtonDisabled}
                    loading={props.isLoading}
                    size="small"
                    type="primary"
                    htmlType="submit"
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginLeft: '6px',
                        width: '30px',
                        height: '30px',
                    }}
                >
                    {!props.isLoading ?
                        <CheckOutlined style={{ paddingTop: '2px' }} />
                    :   <span style={{ width: '30px', height: '30px', display: 'inline-block', paddingLeft: '2px' }} />}
                </Button>
            </div>
        </Form>
    );
};
export default DatePickerTimeRange;
